module.exports = __webpack_public_path__ + "img/jiantou.2b9b96a3.png";